import { render } from "./Mentions-legales.vue?vue&type=template&id=3089e387"
import script from "./Mentions-legales.vue?vue&type=script&lang=js"
export * from "./Mentions-legales.vue?vue&type=script&lang=js"

import "./Mentions-legales.vue?vue&type=style&index=0&id=3089e387&lang=scss"

import exportComponent from "/Users/jeromebart/sites/cdm-quiz/cite-des-metiers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__